import React from "react"
import { useEffect, useState } from "react"
import {
    Box,
    Typography,
    Button,
    Card,
    CardContent,
    Grid,
    FormControl,
    IconButton,
    Stack,
    Autocomplete,
    TextField,
    Select,
    MenuItem,
    Dialog,
    DialogContent,
    DialogTitle,
    FormGroup,
    FormControlLabel,
    Checkbox,
    Pagination,
    Table,
    TableHead,
    TableRow,
    TableCell,
    TableBody,
} from "@mui/material"
import ChevronLeftIcon from "@mui/icons-material/ChevronLeft"
import ChevronRightIcon from "@mui/icons-material/ChevronRight"
import { useSelector } from "react-redux"
import type { RootState } from "../../../global/config/store.ts"
import { ApiGetAllocations, ApiGetClientEntityByClientGroupId, ApiGetShopperList, ApiPostInviteShopper, ApiGetAirTasker, ApideleteInvitedAirTasker } from "../../../apiService/Core/Apicall.tsx"
import { toast } from "react-toastify"
import DeleteIcon from "@mui/icons-material/Delete";

interface VenueOption {
    label: string;
    value: number;
    allocationId: number;
}
interface ShopperOption {
    label: string;
    userId: number;
}

export default function AirTaskerJobs() {
    const [currentDate, setCurrentDate] = useState(new Date())
    const [clientEntityId, setClientEntityId] = useState<string | null>(null)
    const [venueNameValue, setVenueNameValue] = useState<any>(null)
    const [venueName, setVenueName] = useState<VenueOption[]>([]);
    const [selectedVenue, setSelectedVenue] = useState<VenueOption | null>(null)
    const [selectedAirTasker, setSelectedAirTasker] = useState<ShopperOption | null>(null);
    const [allocations, setAllocations] = useState<any[]>([])
    const [clientEntityList, setClientEntityList] = useState<any>([])
    const [shoppersList, setShoppersList] = useState<ShopperOption[]>([])
    const Clientlist = useSelector((state: RootState) => state.client.clientList)
    const [selectedClient, setSelectedClient] = useState<any>(null)
    const [ClientId, setClientId] = useState(null)
    const [airTaskerData, setAirTaskerData] = useState<any[]>([]);

    const ApiCallGetAllocations = async (
        jobMonth: number,
        jobYear: number,
        passedEntityId?: string | number | null
    ) => {
        let data = `?limit=500&jobMonth=${jobMonth}&jobYear=${jobYear}`;

        if (selectedClient?.clientGroupName)
            data += `&allocationClientGroup=${selectedClient.clientGroupName}`;

        const entityIdToUse = passedEntityId ?? clientEntityId;
        if (entityIdToUse)
            data += `&clientEntityId=${entityIdToUse}`;

        try {
            const res = await ApiGetAllocations(data);
            const allAllocations = res?.data || [];
            setAllocations(allAllocations);

            const uniqueVenues: VenueOption[] = Array.from(
                new Map(
                    allAllocations
                        .filter((item: any) => item.venueId?.venueId && item.venueId?.venueName)
                        .map((item: any) => [
                            item.venueId.venueId,
                            {
                                label: item.venueId.venueName,
                                value: item.venueId.venueId,
                                allocationId: item.allocationId,
                            } as VenueOption,
                        ])
                ).values()
            );

            setVenueName(uniqueVenues);
        } catch (error) {
            console.error("Error fetching allocations:", error);
            toast.error("Failed to load allocations");
        }
    };
    const handleGetApiCall = async (status?: string) => {
        try {
            const filterStatus = "active"
            const data = `?offset=0&limit=1000&isAirTasker=true&status=${filterStatus}`
            const res = await ApiGetShopperList(data)
            const formatted = (res.data || []).map((shopper: any) => ({
                label: `${shopper.firstName} ${shopper.lastName}`,
                userId: shopper.userId,
            }));
            setShoppersList(formatted)
        } catch (error) {
            console.error("Error during API call:", error)
        }
    }
    useEffect(() => {
        handleGetApiCall();
    }, []);
    useEffect(() => {
        if (Clientlist.length > 2) {
            setSelectedClient(Clientlist[2])
            setClientId(Clientlist[2].clientGroupName)
        }
    }, [Clientlist])

    const handlePrevMonth = () => {
        setCurrentDate((prevDate) => {
            const newDate = new Date(prevDate.getFullYear(), prevDate.getMonth() - 1, 1)
            const jobMonth = newDate.getMonth() + 1
            const jobYear = newDate.getFullYear()
            ApiCallGetAllocations(jobMonth, jobYear)
            return newDate
        })
    }

    const handleNextMonth = () => {
        setCurrentDate((prevDate) => {
            const newDate = new Date(prevDate.getFullYear(), prevDate.getMonth() + 1, 1)
            const jobMonth = newDate.getMonth() + 1
            const jobYear = newDate.getFullYear()
            ApiCallGetAllocations(jobMonth, jobYear)
            return newDate
        })
    }

    const handleDateChange = (event: React.ChangeEvent<HTMLInputElement>) => {
        const newDate = new Date(event.target.value + "-01")
        setCurrentDate(newDate)
        const jobMonth = newDate.getMonth() + 1
        const jobYear = newDate.getFullYear()
        ApiCallGetAllocations(jobMonth, jobYear)
    }
    const createdBy = localStorage.getItem("createdBy");
    const handleCreateInvite = async () => {
        if (!selectedAirTasker || !selectedVenue) {
            toast.error("Please select both AirTasker and Venue.");
            return;
        }

        const payload = {
            userIds: [selectedAirTasker.userId],
            allocationId: selectedVenue.allocationId,
            createdBy: createdBy
        };

        try {
            const res = await ApiPostInviteShopper(payload);
            toast.success("Shopper invited successfully!");
            const jobMonth = currentDate.getMonth() + 1;
            const jobYear = currentDate.getFullYear();
            const data = `?jobMonth=${jobMonth}&jobYear=${jobYear}`;
            const updatedRes = await ApiGetAirTasker(data);
            setAirTaskerData(updatedRes?.data || []);
            setSelectedAirTasker(null);
            setSelectedVenue(null);
        } catch (error) {
            console.error("Error inviting shopper:", error);
            toast.error("Failed to invite shopper.");
        }
    }

    const formatDate = (date: Date) => {
        return `${date.getFullYear()}-${String(date.getMonth() + 1).padStart(2, "0")}`
    }

    const handleDelete = async (allocationId: number, userId: number) => {
        try {
            if (!window.confirm("Are you sure you want to remove this AirTasker?")) {
                return;
            }

            const response = await ApideleteInvitedAirTasker({
                allocationId,
                userId
            });

            // Match your backend response structure
            if (response?.data?.status === true) {
                toast.success(response.data.message || "AirTasker removed successfully");
            } else {
                // If status is not true, revert UI and show error
                const jobMonth = currentDate.getMonth() + 1;
                const jobYear = currentDate.getFullYear();
                const res = await ApiGetAirTasker(`?jobMonth=${jobMonth}&jobYear=${jobYear}`);
                setAirTaskerData(res?.data || []);

                toast.success(response.data?.message || "AirTasker removed successfully");
            }
        } catch (error) {
            console.error("Delete error details:", {
                error,
                message: error.message,
                response: error.response?.data
            });

            toast.error(
                error.response?.data?.message ||
                error.message ||
                "Failed to remove AirTasker"
            );
        }
    };

    useEffect(() => {
        if (clientEntityId === null) {
            setVenueName([])
        }
    }, [clientEntityId])


    useEffect(() => {
        console.log("ClientId", ClientId)
        handleGetClientList()
    }, [ClientId])

    const handleGetClientList = async () => {
        const data = `?ClientGroupName=${ClientId}`
        if (!ClientId) return
        try {
            const res: any = await ApiGetClientEntityByClientGroupId(data)
            console.log(res.data)
            setClientEntityList(res.data)
        } catch (error) {
            console.error("Error during API call:", error)
        }
    }
    useEffect(() => {
        const jobMonth = currentDate.getMonth() + 1;
        const jobYear = currentDate.getFullYear();
        const data = `?jobMonth=${jobMonth}&jobYear=${jobYear}`
        const fetchAirTaskers = async () => {
            try {
                const res = await ApiGetAirTasker(data);
                setAirTaskerData(res?.data || []);
            } catch (err) {
                console.error("Error fetching AirTasker data", err);
                toast.error("Failed to fetch AirTasker data");
            }
        };
        fetchAirTaskers();
    }, [currentDate]);

    return (
        <Box sx={{ p: 4 }} style={{ background: "white" }}>
            <Stack spacing={3}>
                <Box sx={{ width: "100%" }}>
                    <h1 className="common-manage-h1" style={{ textAlign: "center" }}>
                        Air Tasker Job
                    </h1>
                    <Box
                        sx={{
                            display: "flex",
                            justifyContent: "space-between",
                            marginBottom: "-70px",
                            marginTop: "23px",
                        }}
                    >

                        <Stack direction="row" spacing={2}>
                            <FormControl size="small" sx={{ width: 180 }}>
                                <Autocomplete
                                    disablePortal
                                    id="mm-autocomplete"
                                    options={Clientlist}
                                    value={selectedClient}
                                    getOptionLabel={(option: any) => option?.clientGroupName}
                                    isOptionEqualToValue={(option: any, value: any) =>
                                        option.clientGroupDBName === value.clientGroupDBName
                                    }
                                    onChange={(event, newValue: any) => {
                                        setSelectedClient(newValue)
                                        setClientId(newValue?.clientGroupName || null)
                                        if (!newValue || (selectedClient && newValue.clientGroupName !== selectedClient.clientGroupName)) {
                                            setClientEntityId(null)
                                            setVenueNameValue(null)
                                            setClientEntityList([])
                                        }
                                    }}
                                    defaultValue="mmcommon"
                                    renderInput={(params) => <TextField {...params} label="Select Client" />}
                                    size="small"
                                />
                            </FormControl>
                        </Stack>
                    </Box>
                </Box>

                <Box
                    sx={{
                        display: "flex",
                        justifyContent: "center",
                        alignItems: "center",
                        marginBottom: "70px",
                    }}
                >
                    <IconButton onClick={handlePrevMonth}>
                        <ChevronLeftIcon />
                    </IconButton>
                    <Box sx={{ display: "flex", alignItems: "center", mx: 2 }}>
                        <input
                            type="month"
                            value={formatDate(currentDate)}
                            onChange={handleDateChange}
                            className="primary-color"
                            style={{
                                border: "none",
                                background: "none",
                                fontSize: "1.25rem",
                                fontWeight: "bold",
                                cursor: "pointer",
                                fontFamily: "inherit",
                            }}
                        />
                    </Box>
                    <IconButton onClick={handleNextMonth}>
                        <ChevronRightIcon />
                    </IconButton>
                </Box>
                <Box
                    sx={{
                        display: "flex",
                        flexWrap: "wrap",
                        gap: 2,
                        padding: "15px",
                        borderRadius: "5px",
                        alignItems: "start",
                    }}
                    className="min-border-color"
                >
                    <Stack direction="row" spacing={2}>
                        <FormControl size="small" sx={{ width: 180 }}>
                            <Autocomplete
                                disablePortal
                                id="beacon-autocomplete"
                                options={clientEntityList?.filter((item) => item.clientEntityId !== null)}
                                getOptionLabel={(option) => option?.entityName || ""}
                                onChange={(event, newValue: any) => {
                                    const newClientEntityId = newValue?.clientEntityId || null;
                                    setClientEntityId(newClientEntityId);

                                    if (!newClientEntityId) {
                                        setVenueNameValue(null);
                                        setVenueName([]);
                                        return;
                                    }

                                    const jobMonth = currentDate.getMonth() + 1;
                                    const jobYear = currentDate.getFullYear();

                                    ApiCallGetAllocations(jobMonth, jobYear, newClientEntityId);
                                }}

                                value={clientEntityList?.find((option) => option?.clientEntityId === clientEntityId) || null}
                                renderInput={(params) => <TextField {...params} label="Select Business" />}
                                size="small"
                            />
                        </FormControl>
                        <FormControl size="small" sx={{ width: 180 }}>
                            <Autocomplete
                                id="venue-autocomplete"
                                options={venueName}
                                value={venueName.find((option: any) => option.value === selectedVenue?.value) || null}
                                onChange={(event, newValue: any) => {
                                    setSelectedVenue(newValue || null);
                                    console.log("Selected allocationId:", newValue?.allocationId);
                                }}
                                renderInput={(params) => <TextField {...params} label="Select Venue" />}
                                size="small"
                            />
                        </FormControl>
                        <FormControl size="small" sx={{ width: 180 }}>
                            <Autocomplete
                                disablePortal
                                id="airtasker-autocomplete"
                                options={shoppersList}
                                getOptionLabel={(option) => option.label}
                                isOptionEqualToValue={(option, value) => option.userId === value.userId}
                                onChange={(event, newValue) => {
                                    console.log("Selected AirTasker:", newValue);
                                    setSelectedAirTasker(newValue || null);
                                }}
                                renderInput={(params) => <TextField {...params} label="Select AirTasker" />}
                                size="small"
                            />
                        </FormControl>


                    </Stack>
                    <Box sx={{ display: "grid", gap: "20px", marginLeft: "auto" }}>
                        <Box sx={{ marginLeft: "auto", display: "flex", gap: 2 }}>
                            <Button variant="contained" className="table-row-background" onClick={handleCreateInvite} disabled={!selectedVenue || !selectedAirTasker}>
                                create
                            </Button>
                        </Box>
                    </Box>
                </Box>
            </Stack>
            <Box sx={{ mt: 4, overflowX: "auto"}}>
                <Table sx={{ minWidth: 600 }}>
                    <TableHead>
                        <TableRow className="table-row-background">
                            {["First Name", "Last Name", "venueName", "Email ID", "Delete Shopper"].map((item) => (
                                <TableCell key={item} style={{ color: "#fff", whiteSpace: "nowrap" }}>
                                    {item}
                                </TableCell>
                            ))}
                        </TableRow>
                    </TableHead>
                    <TableBody>
                        {airTaskerData.length === 0 ? (
                            <TableRow>
                                <TableCell colSpan={5} align="center">
                                    No data found
                                </TableCell>
                            </TableRow>
                        ) : (
                            airTaskerData.map((item, index) => (
                                <TableRow key={index}>
                                    <TableCell>{item?.firstName || "-"}</TableCell>
                                    <TableCell>{item?.lastName || "-"}</TableCell>
                                    <TableCell>{item?.venueName || "-"}</TableCell>
                                    <TableCell>{item?.emailId || "-"}</TableCell>
                                    <TableCell>
                                        <Button variant="contained" className="delete-transparent">
                                            <DeleteIcon className="delete-icon" onClick={() => handleDelete(item.allocationId, item.userId)} />
                                        </Button>
                                    </TableCell>
                                </TableRow>
                            ))
                        )}
                    </TableBody>

                </Table>
            </Box>

        </Box>
    )
};